import React from 'react';
import classNames from 'classnames';
import { addressFormatter, optionClassFormatter } from '../../../utils/formatters';
import {
  CamerasActionsFormatter,
  StatusFormatterWithProblem,
  CamerasWorkingStateFormatter,
} from './CamerasFormatters';
import { Icons } from '../../../components/base/BootstrapComponents';
import { processingFormatter } from '../camera-utils';

export default function MobileCamerasItem(props) {
  const { showOnMap = () => {}, item, handleClose } = props;
  if (!item) {
    return null;
  }
  return (
    <div className="mc-host-block">
      <div className={classNames('mpm-host', optionClassFormatter(item.status))}>
        Видеокамера: {item.name}
        {handleClose ? <Icons icon="close" customIcon className="close" onClick={handleClose} /> : null}
      </div>
      <div className="mpm-info mpm-address">
        <div className="mpm-label">Адрес</div>
        {addressFormatter(item.zbx_address, true, item.zbx_zone, true, () => showOnMap(item))}
      </div>
      <div className="mpm-info mpm-working-state">
        <div className="mpm-label">Работа устройства</div>
        <CamerasWorkingStateFormatter item={item} isPopup={false} />
      </div>
      <div className="mc-status-block">
        <div className="mc-status-block-info mpm-working-state">
          <div className="mpm-label">Состояние</div>
          <StatusFormatterWithProblem item={item} />
        </div>
        <div className="mc-status-block-info mpm-working-state">
          <div className="mpm-label">Процессинг</div>
          {processingFormatter(item.metrics)}
        </div>
      </div>
      <div className="mpm-info mpf-buttons">
        <CamerasActionsFormatter item={item} isMobile />
      </div>
    </div>
  );
}
